module.exports = __webpack_public_path__ + "static/e6beefbb-4014-4efa-961b-7762af9aefef-c7f81325ce40204a9f4d95b1c1bd1ffc.woff2";